import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function TruckIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M13.3333 2.5H.833252v10.8333H13.3333V2.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3333 6.66699h3.3333l2.5 2.5v4.16671h-5.8333V6.66699ZM4.58333 17.4997c1.1506 0 2.08334-.9328 2.08334-2.0834 0-1.1506-.93274-2.0833-2.08334-2.0833-1.15059 0-2.08333.9327-2.08333 2.0833 0 1.1506.93274 2.0834 2.08333 2.0834Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4166 17.4997c1.1506 0 2.0833-.9328 2.0833-2.0834 0-1.1506-.9327-2.0833-2.0833-2.0833-1.1506 0-2.0833.9327-2.0833 2.0833 0 1.1506.9327 2.0834 2.0833 2.0834Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
